// Constants
import { VERSION_UPDATE_AVAILABLE } from './versionConstants';

export const versionUpdateAvailable = ({ safe }) => ({ type: VERSION_UPDATE_AVAILABLE, safe });
